import { Box, Chip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { formatNumber } from 'switch-shared/utils/formatters';

import { onlineStatusColor } from '../utils/onlineStatus';

export interface MeterTagCount {
  label: string;

  online: number;

  total: number;
}

interface Props {
  counts: MeterTagCount[];
}

/** Meter totals side by side, each with a chip of its online share. */
const MeterTagCounts = ({ counts }: Props) => {
  const theme = useTheme();

  return (
    <Box
      display='grid'
      gridTemplateColumns={`repeat(${counts.length}, 1fr)`}
      alignItems='center'
      height='100%'
      gap={1}
      textAlign='center'
    >
      {counts.map(({ label, online, total }) => (
        <Box key={label}>
          <Typography variant='caption' color='text.secondary' display='block'>
            {label}
          </Typography>
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontWeight: theme.tokens.typography.fontWeight.bold,
              fontSize: theme.tokens.typography.fontSize.xl,
              lineHeight: 1.4,
            }}
          >
            {formatNumber(total, 0)}
          </Typography>
          <Chip
            size='small'
            label={total > 0 ? `${Math.round((online / total) * 100)}%` : '—'}
            sx={{
              backgroundColor: onlineStatusColor(theme, online, total),
              color: theme.palette.common.white,
              fontWeight: theme.tokens.typography.fontWeight.semibold,
              cursor: 'default',
            }}
          />
        </Box>
      ))}
    </Box>
  );
};

export default MeterTagCounts;
